/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import CardHeader from '../../../../../components/CardHeader'
import { useNavigate } from 'react-router-dom';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
import { dataService } from '../../../../../services/data.services';
import Debounce from '../../../../../CommonMethods/Debounce';
import CustomOverLay from '../../../../../components/CustomOverlay';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import Toast from '../../../../../components/Toast';
import GlobalContext from '../../../../../components/Context/GloablContext';
import ConfirmationModel from '../../../../../components/ConfirmationModel';
import { CognitoData } from '../../../../../CommonMethods/CognitoData';
import Input from '../../../../../components/InputBox';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import DropDownComponent from './DropDownComponent';
import { ShimmerTitle } from 'react-shimmer-effects'

export default function AddTransferStudent() {
    const location = useNavigate();
    const { setToastmessage } = useContext(GlobalContext);
    const inputRef = useRef()
    const inputRefStudent = useRef();
    const refTransfer = useRef();
    const buttonRefTransfer = useRef(null);
    const dropdownRefTransfer=useRef(null)
    const [isOpenTransfer, setisOpenTransfer] = useState(false);
    const [isOpenOther, setisOpenOther] = useState(false);

    const refOther = useRef();
    const buttonRefOther = useRef(null);
    const dropdownRefOther =useRef(null)
    const [loading, setLoading] = useState(true);
    const [submitSelected, setsubmitSelected] = useState(false);
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const [studentDropdownData, setStudentDropdownData] = useState([])
    const [selectedSearchStudent, setSelectedSearchStudent] = useState('')
    const [errorState, setErrorState] = useState(false);
    const [state, setState] = useState({ transfers_type: "Other Section", transfers_to : "" })
    const [studentSelected, setStudentSelected] = useState(false)
    const [cancelStudentSelected, setCancelStudentSelected] = useState(false)
    const [approveConformation, setApproveConformation] = useState(false)
    const [dropdownOtherData, setDropDownOtherData] = useState([]);
    const [isOutstandingFee, setIsOutStandingFee] = useState(false)
    const transfer_to = [{ name: "Other Section" }, { name: "Other Branch" }, { name: "Other" }]
    const [studentSearchStarted,setStudentSearchStarted]=useState(false)
    const [showStudentsDropdownData,setShowStudentDropdownData]=useState(false)
    const [dropdownOtherDataLoading, setDropDownOtherDataLoading] = useState([]);
    

    const handleStudentSearch = async (search) => {
        setsubmitSelected(false);
        setStudentSearchStarted(true)
        setShowStudentDropdownData(false)
        setStudentDropdownData([])
        setErrorState(false);
        const branch_id = await GetBranchId()
        setToastErrorMessage("")
        let searchValue = encodeURIComponent(search).replace(/[#&]/g, '\\$&').trim()
        if (searchValue.trim() !== "") {
            setTimeout(async () => {
                let response = null
                response = await dataService.GetAPI(`students?filter=true&status=active&branch_id=${branch_id}&search=${searchValue}&is_academic_year=true&role=transfers`, true);
                setShowStudentDropdownData(true)
                setStudentDropdownData(response?.data?.data?.students)
            }, 700);
        } else {
            setStudentDropdownData([])
            setShowStudentDropdownData(false)
            setStudentSearchStarted(false)
        }
    }

    const handleStudentSearchParams = useCallback(
        Debounce((value) => handleStudentSearch(value)),
        []
    );

    const handleDropdown = (key) => {
        setToastErrorMessage('')
        setsubmitSelected(false);
        setshowDropdown((prv) => ({
            ...prv,
            [key]: !showDropdown[key],
        }));
    };

    const getPasscode = async () => {
        const branch_id = await GetBranchId()
        const res = await dataService.GetAPI(`transfer-students/credentials?branch_id=${branch_id}`);
        setState((prevState) => ({
            ...prevState,
            passcode : res?.data?.data?.passcode,
            transfer_id : res?.data?.data?.transfer_id
        }));
        setLoading(false)
    };

    useOnClickOutside(inputRefStudent, () => {
        setStudentDropdownData([])
        setShowStudentDropdownData(false)
        setStudentSearchStarted(false)
    });

    const handleSelectDropDown = async (key, value) => {
        setToastErrorMessage("")
        setsubmitSelected(false);
        setErrorState(false);
        switch (key) {
        case "student_select":
            setState((prv) => ({
                ...prv,
                student_id: value?.student_id,
                student_name: value?.full_name,
                class_id: value?.classes?.class_id,
                section_id: value?.sections?.section_id,
                section_name: value?.sections?.section_name,
                class_name: value?.classes?.class_name,
                academic_year_name: value?.academic_year?.name,
                academic_year_id : value?.academic_year?.academic_year_id,
                outStanding_fee: value?.total_remaining_amount,
                student_uuid: value?._id
            }))
            setSelectedSearchStudent("")
            setStudentSelected(true)
            setStudentDropdownData([])
            setShowStudentDropdownData(false);
            setStudentSearchStarted(false);
            getOtherSectionOrBranch(state?.transfers_type, value)
            break;
        case "student_cancel":
            setState({
                transfer_id: state.transfer_id,
                passcode : state.passcode,
                transfers_type : "Other Section",
                transfer_to : "",
            });
            setStudentSelected(false)
            setCancelStudentSelected(false)
            break;
        case "transfers_type":
            setState((prv) => ({
                ...prv,
                transfers_type: value?.name,
                transfers_to: value?.name === state.transfers_type ? state.transfers_type : ""
            }))
            getOtherSectionOrBranch(value?.name)
            setCancelStudentSelected(false)
            break;
        case "transfers_to" :
            if(state.transfers_type === "Other Section") {
                setState((prv) => ({
                    ...prv,
                    transfers_to: value?.section_name,
                    transferred_section_id : value?.section_id,
                }))
            } else {
                setState((prv) => ({
                    ...prv,
                    transfers_to: value?.branch_name,
                    transferred_branch_id : value?._id
                }))
            }
            break;
        default:
            break;
        }
    }

    /**
     * The function `getOtherSectionOrBranch` retrieves data based on a key and updates the state with
     * the response.
     */
    const getOtherSectionOrBranch = async (key, data) => {
        const branch_id = await GetBranchId()

        setDropDownOtherDataLoading(true)
        if(key === "Other Section") {
            const response = await dataService.GetAPI(`associations?branch_id=${branch_id}&academic_year_id=${data === undefined ? state.academic_year_id : data?.academic_year?.academic_year_id}&class_id=${data === undefined ? state.class_id : data?.classes?.class_id}&filter=true&role=transfers`, true);
            setDropDownOtherData(response?.data?.data?.data.filter(obj => obj.section_id !== (data === undefined ? state?.section_id : data.sections?.section_id)))
        } else {
            const user = await CognitoData();
            const res = await dataService.GetAPI(`branch?role=transfers&branch_id=${branch_id}&institution_id=${user.idToken.payload["custom:institution_id"]}&filter=true&status=true`, true);
            const list = res?.data?.data?.data.filter(obj => obj._id !== branch_id)
            setDropDownOtherData(list)
        }
        setDropDownOtherDataLoading(false)
    }

    useEffect(() => {
        getPasscode();
    }, [])

    const handleApprove = async() => {
        setErrorState(false);
        if(state.outStanding_fee !== 0 && (state.transfers_type === "Other Branch" || state.transfers_type === "Other")) {
            setIsOutStandingFee(true);
        }else if(!studentSelected || state.transfers_to === undefined || state.transfers_to === "") {
            setErrorState(true)
            setToastErrorMessage("Please fill in the mandatory field")
        } else {
            setApproveConformation(true);
        }
    }
    const [loadingButton, setLoadingButton] = useState(false)
    const handelApproveButton = async() => {
        const branch_id = await GetBranchId()
        setLoadingButton(true)
        try {
            let body = {
                "student_name": state?.student_name,
                "student_id": state?.student_id,
                "class_id": state?.class_id,
                "section_id": state?.section_id,
                "section_name": state?.section_name,
                "class_name": state?.class_name,
                "academic_year_name": state?.academic_year_name,
                "academic_year_id" : state?.academic_year_id,
                "branch_id": state?.branch_id,
                "transfer_id": state?.transfer_id,
                "passcode": state?.passcode,
                "transfers_type": state?.transfers_type,
                "transfers_to": state?.transfers_to,
                "branch_id": branch_id,
                'student_uuid': state?.student_uuid
            }
            if(state.transfers_type === "Other Section") {
                body["transferred_section_id"] = state.transferred_section_id
            }
            if(state.transfers_type === "Other Branch") {
                body["transferred_branch_id"] = state.transferred_branch_id
            }
            const response = await dataService.PostAPI(body,`transfer-students` );
            setToastmessage(response.data.data.message)
            setLoadingButton(false);
            setApproveConformation(false)
            location("/student-master/transfers?type=outward_list")
        } catch (error) {
            console.log(error)
            setLoadingButton(false);
            setApproveConformation(false)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
    }
    const handleInput = (e, val, idd) => {
        setToastErrorMessage('')
        const { id, value } = e.target;
        setState((prv) => ({
            ...prv,
            [id]: value,
        }));
    };
    const handleClearSearch = () => {
        setCancelStudentSelected(true)
    }
    return (
        <>
            <CardHeader noPadding>
                <div
                    class="mainDataCntnrTop shadow-s13"
                    style={{ position: "sticky", position: -"webkit-sticky;" }}
                >
                    <h5 class="pageHeader adderror">
                        Transfer Student
                    </h5>
                    <div class="flex items-center">
                        <button
                            onClick={() => location("/student-master/transfers?type=outward_list")}
                            type="button"
                            class="cancl-btn"
                        >
                            Cancel
                        </button>
                        <button
                            // disabled={loading}
                            type="submit"
                            id="sumbit-button"
                            className={"actn-btn onboardInstitution"}
                            onClick={() => handleApprove()}
                        >
                            Approve
                        </button>
                    </div>
                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
                {loading ?
                    <CustomOverLay
                        Active
                        text="Loading..."
                        classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}
                    /> :
                    <div>
                        <div className="mainDataCntnrPageDiv scrollBlue_thick">
                            <div className='w-[760px] mx-auto'>
                                <div class="relative w-full" ref={inputRefStudent}>
                                    {!studentSelected ?
                                        <input
                                            type="text"
                                            id='student_name'
                                            disabled={studentSelected}
                                            autoComplete='off'
                                            // title={selectedSearchStudent}
                                            className={`${!(errorState || studentSelected) ? "" : "redBorder"}  slct-inpt-fld error_border`}
                                            placeholder="Search by Student Name / ID"
                                            onChange={event => { setSelectedSearchStudent(event.target.value); handleStudentSearchParams(event.target.value) }}
                                            value={studentSelected ? `${state?.student_name} [${state?.student_id}], ${state?.class_name}, ${state?.section_name}` : selectedSearchStudent}
                                        />
                                        :
                                        <>
                                            <div className="  slct-inpt-fld error_border bg-[#E6E8EA]">
                                                <div className="grow shrink basis-0 h-6 items-center gap-2 flex">
                                                    <div className="grow shrink basis-0 text-slate-900 text-[15px] font-semibold font-['Inter'] leading-normal">
                                                        <span className='more-lines break-words word_line_break w-[68%]' title={`${state?.student_name} [${state?.student_id}], ${state?.class_name}, ${state?.section_name}`} >
                                                            {`${state?.student_name} [${state?.student_id}], ${state?.class_name}, ${state?.section_name}`}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="w-6 relative" />
                                            </div>
                                        </>
                                    }
                                    <button class="absolute top-[50%] -translate-y-[50%] right-2 flex">
                                        {studentSelected && <div className="grow shrink basis-0 h-6 items-center gap-2 flex mr-6">
                                            <div className="grow shrink basis-0 text-slate-900 text-[15px] font-semibold font-['Inter'] leading-normal">
                                                Outstanding Fee: <span id='outstanding_amt'>{(state?.outStanding_fee).toFixed(2)}</span>
                                            </div>
                                        </div>}
                                        <img
                                            loading="lazy"
                                            decoding="async"
                                            src={studentSelected ? "/images/cancel.svg" : "/images/search.svg"}
                                            alt="img"
                                            onClick={
                                                () => {
                                                    studentSelected ?
                                                        handleClearSearch() :
                                                        handleStudentSearch(selectedSearchStudent)
                                                }} />
                                    </button>
                                    {studentSearchStarted && (<ul class="slct_drp_dwn min-w-full [&[data-te-dropdown-show]]:block select_student" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref>
                                        <li class="max-h-[150px] overflow-auto scroll-bar" >
                                            {showStudentsDropdownData ?
                                                studentDropdownData?.length === 0 ? (
                                                    <ul>
                                                        <li>
                                                            <a
                                                                onClick={() => { }}
                                                                className="selected_Class"
                                                                href="#"
                                                                data-te-dropdown-item-ref
                                                            >
                                                                - No student found / Insufficient AY Details -
                                                            </a>
                                                        </li>
                                                    </ul>
                                                ) : (
                                                    !studentSelected && studentDropdownData?.map((student, index) => (
                                                        <ul key={student.student_id}>
                                                            <li>
                                                                <a
                                                                    onClick={() => handleSelectDropDown("student_select", student)}
                                                                    title={`${student?.full_name} [${student?.student_id}], ${student?.classes?.class_name}, ${student?.sections?.section_name}`}
                                                                    id={index + 'transfer'}
                                                                    class="hover:bg-blue-50  cursor-pointer block w-full more-lines bg-white px-2 py-2 my-0.5 text-f7 font-normal text-[#031624] selected_Class" href="#" data-te-dropdown-item-ref>
                                                                    {`${student?.full_name} [${student?.student_id}], ${student?.classes?.class_name}, ${student?.sections?.section_name}`}
                                                                </a>
                                                            </li>

                                                        </ul>
                                                    )
                                                    )
                                                ) : (
                                                    <li className="max-h-[150px] overflow-auto scroll-bar" style={{ 'padding': '0rem 0.5rem' }}>
                                                        <p className="text-2xl font-bold text-[#031624] mb-4 mt-2"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                                                    </li>
                                                )}
                                        </li>
                                    </ul>)}
                                </div>

                            </div>
                            <div className='w-[760px] mx-auto mt-6'>
                                <div className='border border-[#D0D5DD] p-3 rounded'>
                                    <div className='flex -mx-10'>
                                        <div className='w-[50%] px-14'>
                                            <div className='flex'>
                                                <div className=' flex items-center mb-4 w-full relative'>
                                                    <label htmlFor="transfer_id" className="text-f7 font-normal text-[#031624] min-w-[95px] inline-flex">Transfer ID</label>
                                                    <div className="relative w-full" ref={inputRef}>
                                                        <input
                                                            id='transfer_id'
                                                            disabled={true}
                                                            type="text"
                                                            className={`inpt-fld error_border`}
                                                            placeholder="Search by Class"
                                                            value={state?.transfer_id}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='flex'>
                                                <div className=' flex items-center mb-4 w-full relative'>
                                                    <label htmlFor="passcode" className="text-f7 font-normal text-[#031624] min-w-[95px] inline-flex">Passcode</label>
                                                    <div className="relative w-full" ref={inputRef}>
                                                        <input
                                                            id='passcode'
                                                            type="text"
                                                            disabled={true}
                                                            className={`inpt-fld error_border`}
                                                            placeholder="Search by Class"
                                                            value={state?.passcode}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='w-[50%] px-14'>
                                            <div className='flex'>
                                                <div className='relative flex items-center mb-4 w-full'>
                                                    <label for="ledger_name" class="text-f7 font-normal text-[#031624] min-w-[100px] inline-flex">Transfer to</label>
                                                    <DropDownComponent
                                                        divClassName={"relative w-[232px]"}
                                                        showErrorBorder={submitSelected}
                                                        options={transfer_to}
                                                        dropdownkey={"transfers_type"}
                                                        studentDetails={state}
                                                        submitSelected={submitSelected}
                                                        // showDropdown={showDropdown}
                                                        handleDropdown={handleDropdown}
                                                        placeholder={"Select Transfer to"}
                                                        buttonDisabled={!studentSelected}
                                                        selectedvalue={state.transfers_type}
                                                        stateStatus={false}
                                                        value={state.transfers_type}
                                                        handleOnchangeInput={handleSelectDropDown}
                                                        dropDownName={"transfers_type"}
                                                        dropdownId
                                                        SameName
                                                        divRef={refTransfer}
                                                        buttonNameRef={buttonRefTransfer}
                                                        dropdownNameRef={dropdownRefTransfer}
                                                        isOpen={isOpenTransfer}
                                                        setisOpen={setisOpenTransfer}
                                                        applyBGForDisabled={true}
                                                    />
                                                </div>
                                            </div>
                                            <div className='flex'>
                                                <div className='relative flex items-center mb-4 w-full'>
                                                    <label htmlFor="" class="text-f7 font-normal text-[#031624] min-w-[100px] inline-flex">{state.transfers_type === "Other Section" ? "Section" :  state.transfers_type === "Other" ? "Other" :"Branch"}</label>
                                                    {state.transfers_type === "Other" ?
                                                        <Input
                                                            type="text"
                                                            state={state}
                                                            id='transfers_to'
                                                            placeholder="Specify Other"
                                                            handleInput={handleInput}
                                                            submitSelected={errorState}
                                                            setsubmitSelected={setErrorState}
                                                        /> :
                                                        <DropDownComponent
                                                            divClassName={"relative w-[195px]"}
                                                            showErrorBorder={(errorState && (state?.transfers_to === undefined || state?.transfers_to === ""))}
                                                            options={dropdownOtherData}
                                                            dropDownName={"transfers_to"}
                                                            studentDetails={state}
                                                            submitSelected={submitSelected}
                                                            handleOnchangeInput={handleSelectDropDown}
                                                            handleDropdown={handleDropdown}
                                                            buttonDisabled={!studentSelected || state.transfers_type === "Other"}
                                                            placeHolder={`Select ${state.transfers_type === "Other Section" ? "Section" : "Branch"}`}
                                                            selectedvalue={state?.transfers_to}
                                                            stateStatus={false}
                                                            value={state?.transfers_to}
                                                            optionsKey={state.transfers_type !== "Other Section" ? "branch_name" : "section_name"}
                                                            dropdownId
                                                            divRef={refOther}
                                                            buttonNameRef={buttonRefOther}
                                                            dropdownNameRef={dropdownRefOther}
                                                            isOpen={isOpenOther}
                                                            setisOpen={setisOpenOther}
                                                            applyBGForDisabled={true}
                                                            isLoading={dropdownOtherDataLoading}
                                                        />}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </CardHeader>
            {cancelStudentSelected &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={() => { handleSelectDropDown("student_cancel") }}
                            handleClose={() => { setCancelStudentSelected(false) }}
                            tittle={``}
                            message={`Are you sure you want to clear the student details?`}
                            buttonName={`OK`}
                            loadingActivation={false}
                        />
                    }
                />
            }
            {approveConformation &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handelApproveButton}
                            handleClose={() => { setApproveConformation(false) }}
                            tittle={`Transfer Student`}
                            additionalMessage={`Once the student is transferred, this action cannot be undone.`}
                            message="Would you like to proceed?"
                            buttonName={`Proceed`}
                            loadingActivation={loadingButton}
                            dialogueWidth={'500px'}
                            textPosition={'text-start'}
                        />
                    }
                />
            }
            {isOutstandingFee &&
                <AnimatedModel
                    Children={
                        <ConfirmationModel
                            handleOnCLickActivate={handelApproveButton}
                            maxWidth={'580px'}
                            handleClose={() => { setIsOutStandingFee(false) }}
                            message={<>Student cannot be transferred due to pending fees. <br/>
                                To proceed, use the &#39;Collect Fee&#39; option and clear the outstanding invoices.</>}
                            buttonName={`OK`}
                            loadingActivation={loadingButton}
                        />
                    }
                />
            }
        </>
    )
}
